import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { map } from 'lodash';

import { personFromApi, companyFromApi, metaFromApi } from 'helpers/contacts/api_helpers';

import { clearFilters } from '../actions/query';
import { duplicateCompaniesPath, duplicatePeoplePath } from '../selectors/paths';

export const RESET_DUPLICATES_STATE = 'RESET_DUPLICATES_STATE';
export function resetDuplicatesState() {
  return { type: RESET_DUPLICATES_STATE };
}

export const SET_DUPLICATE_CONTACTS = 'SET_DUPLICATE_CONTACTS';
export const loadPeopleSuccess = (people, groups, meta) => (
  { type: SET_DUPLICATE_CONTACTS, payload: { people, groups, meta } }
);

export const loadCompaniesSuccess = (companies, groups, meta) => (
  { type: SET_DUPLICATE_CONTACTS, payload: { companies, groups, meta } }
);

export const START_LOADING = 'START_DUPLICATES_LOADING';
export function startLoading() {
  return { type: START_LOADING };
}

export const SHOW_DUPLICATES = 'SHOW_DUPLICATES';
export function showDuplicates() {
  return { type: SHOW_DUPLICATES };
}

export const HIDE_DUPLICATES = 'HIDE_DUPLICATES';
export function hideDuplicates() {
  return { type: HIDE_DUPLICATES };
}

export function retrievePeopleDuplicates(page = 1) {
  return (dispatch, getState) => {
    const state = getState();
    const path = duplicatePeoplePath(state);
    dispatch(startLoading());

    return axios.get(path, { params: { page } }).then(({ data: { duplicates, groups, meta } }) => {
      const dupPeople = map(duplicates, duplicate => personFromApi(duplicate));
      dispatch(loadPeopleSuccess(dupPeople, camelcaseKeys(groups), metaFromApi(meta)));
    });
  };
}

export function retrieveCompaniesDuplicates(page = 1) {
  return (dispatch, getState) => {
    const state = getState();
    const path = duplicateCompaniesPath(state);
    dispatch(startLoading());

    return axios.get(path, { params: { page } }).then(({ data: { duplicates, groups, meta } }) => {
      const dupCompanies = map(duplicates, duplicate => companyFromApi(duplicate));
      dispatch(loadCompaniesSuccess(dupCompanies, camelcaseKeys(groups), metaFromApi(meta)));
    });
  };
}

export function toggleView(viewActive) {
  return (dispatch, getState) => {
    if (viewActive) {
      const { ui } = getState();
      dispatch(showDuplicates());

      if (ui.currentTab === 'people') {
        dispatch(retrievePeopleDuplicates());
      } else {
        dispatch(retrieveCompaniesDuplicates());
      }  
    } else {
      dispatch(hideDuplicates());
      dispatch(clearFilters());
    }
  };
}
